import { parseWithdrawalError, type WithdrawalErrorInfo } from '../../../domain/withdrawals/withdrawalErrors';
import { errorMessageOf } from '../feedback/QueryState';

type T = (key: string, vars?: Record<string, string | number>) => string;

/**
 * Localised copy for a failed withdrawal call, chosen from the structured problem `code` (never the English
 * `detail`).
 */
export function withdrawalErrorText(error: unknown, t: T, info: WithdrawalErrorInfo = parseWithdrawalError(error)): string {
  switch (info.code) {
    case 'WITHDRAWALS_DISABLED':
      return t('withdrawals.errDisabled');
    case 'INSUFFICIENT_FUNDS':
      return t('withdrawals.errInsufficient');
    case 'IDEMPOTENCY_CONFLICT':
      return t('withdrawals.errConflict');
    case 'INVALID_TRANSITION':
    case 'METHOD_MISMATCH':
      return t('withdrawals.errTransition');
    case 'ACCOUNT_CLOSED':
      return t('withdrawals.errClosed');
    case 'FORBIDDEN_TIER':
      return t('withdrawals.errTier');
    case 'PAYOUT_DETAILS_MISSING':
      return t('withdrawals.errPayoutMissing');
    case 'VALIDATION_FAILED':
      return t('withdrawals.errValidation');
    default:
      if (info.status === null) return t('withdrawals.errNetwork'); // timeout / offline: outcome unknown, retry is idempotent
      if (info.status === 503) return t('withdrawals.errDisabled');
      return errorMessageOf(error, t('common.error'), t);
  }
}
